import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AttributeValue,
  EditedAttributeValues,
  SectionInstance,
} from '../../../models/section-definition.model';
import { StaticDropdownOption } from '../static-field-rows/static-dropdown-edit-row/static-dropdown-edit-row.component';

@Component({
  selector: 'lib-section-instance-column',
  standalone: false,
  templateUrl: './section-instance-column.component.html',
  styleUrls: ['./section-instance-column.component.scss'],
})
export class SectionInstanceColumnComponent {
  @Input() sections: SectionInstance[] = [];
  @Input() equipmentInstances: Record<string, any[]> = {};
  @Input() isSubstation: boolean = false;
  @Input() columnAlign: 'center' | 'right' = 'center';
  @Input() editEnabled: boolean = false;
  @Input() editableAttributeIds: number[] = [];
  @Input() editedValues: EditedAttributeValues = {};
  @Input() equipmentEditableAttributeIds: number[] = [];
  @Input() editedEquipmentValues: Record<string, EditedAttributeValues> = {};
  @Input() isAssetRatingEditable: boolean = false;
  @Input() assetRatingOptions: StaticDropdownOption<number>[] = [];
  @Input() editedAssetRatings: Record<string, number | null> = {};
  @Output() mapClicked = new EventEmitter<AttributeValue>();

  onMapClick(attributeValue: AttributeValue) {
    this.mapClicked.emit(attributeValue);
  }
}
